import { z } from 'zod';

/**
 * Search form schema for 統計一覧表 — /rezepts/statistical_init.
 *
 * 提出年月 has only required validation.
 */
export const statisticalSearchSchema = z.object({
  searchYearmonthWareki: z.string().min(1, '【提出年月】を入力してください'),
  massagerId: z.number().int().positive().nullable(),
});

export type StatisticalSearchSchemaValues = z.infer<typeof statisticalSearchSchema>;
